import { CommonModule } from '@angular/common';
import { NgModule, Injector, ModuleWithProviders } from '@angular/core';
import { AppComponent } from './app.component';
import { UiNdmsModule } from '../../shared/ui-ndms/ui-ndms.module';
import { CoreHirModule } from './shared/core-hir/core-hir.module';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { AuthModule, OidcSecurityService } from "angular-auth-oidc-client";
import { CoreModule } from "../../shared/core/core.module";
import { UiHirModule } from "./shared/ui-hir/ui-hir.module";
import { RmsUserGuideService } from 'projects/rms/app/shared/core-rms/rms-user-guide.service';

import {
  appNameFactory,
  appPathFactory,
  getBaseUrl,
  identityUrlFactory,
  siteMode,
  userGuides
} from "./app.module.browser";

const providers = [
  OidcSecurityService,
  { provide: 'BASE_URL', useFactory: getBaseUrl },
  { provide: 'ORIGIN_URL', useFactory: getBaseUrl },
  { provide: 'IDENTITY_URL', useFactory: identityUrlFactory },
  { provide: 'APP_PATH', useFactory: appPathFactory },
  { provide: 'APP_NAME', useFactory: appNameFactory },
  { provide: 'SITE_MODE', useFactory: siteMode},
  { provide: 'USER_GUIDES', useFactory: userGuides},
  RmsUserGuideService
];

// @ts-ignore

@NgModule({
  declarations: [
    AppComponent
  ],
  providers:providers,
  imports: [
    CommonModule,
    CoreHirModule,
    CoreModule,
    UiNdmsModule,
    UiHirModule,
    AuthModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
  ]
})

export class AppModuleShared {}
@NgModule({})
export  class HirAppModuleShared{
  static forRoot() : ModuleWithProviders {
    return {
      ngModule: AppModuleShared,
      providers: providers
    }
  }
}